import { cartesian2Polar, polar2Cartesian } from "../color/helpers.js";
export const constant = (c) => () => c;
export const linear = (a, d) => (t) => a + t * d;
// function linear(a, d) {
//   return function(t) {
//     return a + t * d;
//   };
// }
export const exponential = (a, b, y) => {
    a = Math.pow(a, y);
    b = Math.pow(b, y) - a;
    y = 1 / y;
    return (t) => Math.pow(a + t * b, y);
};
// function exponential(a, b, y) {
//   return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
//     return Math.pow(a + t * b, y);
//   };
// }
export const hue = (a, b) => {
    const d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
};
// export function hue(a, b) {
//   var d = b - a;
//   return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
// }
export const gamma = (y) => (y = +y) === 1 ? nogamma : (a, b) => b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
// export function gamma(y) {
//   return (y = +y) === 1 ? nogamma : function(a, b) {
//     return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
//   };
// }
const nogamma = (a, b) => {
    const d = b - a;
    return d ? linear(a, d) : constant(isNaN(a) ? b : a);
};
export default nogamma;
// export default function nogamma(a, b) {
//   var d = b - a;
//   return d ? linear(a, d) : constant(isNaN(a) ? b : a);
// }
export const polarAsCartesian = (a_angle, a_length, b_angle, b_length) => {
    const a_xy = polar2Cartesian(a_angle, a_length);
    const b_xy = polar2Cartesian(b_angle, b_length);
    const x = linear(a_xy.x, b_xy.x);
    const y = linear(a_xy.y, b_xy.y);
    return (t) => cartesian2Polar(x(t), y(t));
};
export const cartesianAsPolar = (a_x, a_y, b_x, b_y) => {
    const a_al = cartesian2Polar(a_x, a_y);
    const b_al = cartesian2Polar(b_x, b_y);
    const a = hue(a_al.angle, b_al.angle);
    const l = linear(a_al.length, b_al.length);
    return (t) => polar2Cartesian(a(t), l(t));
};
export const cartesianAsPolarLong = (a_x, a_y, b_x, b_y) => {
    const a_al = cartesian2Polar(a_x, a_y);
    const b_al = cartesian2Polar(b_x, b_y);
    const a = nogamma(a_al.angle, b_al.angle);
    const l = linear(a_al.length, b_al.length);
    return (t) => polar2Cartesian(a(t), l(t));
};
